/**
 * 单独封装公共方法
 */
 export default {
   /**
    * isInteger判断是不是整数
    * enlarge 计算位移图和背景放大的倍数，这个倍是UI提供的
    */
   isInteger(obj,num){//obj：运算的数 num：对比的数
       return typeof obj === 'number' && obj%num === 0;
   },

   enlarge(wid,hei){//wid 推荐位的宽度 hei推荐位的高度

     let size = {backdrop:"",shifting:""};//backdrop背景的倍数 shifting：位移图的大小

     if(wid == "1665" && hei === "217"){

       size = {backdrop:"1.03",shifting:"1.14"}

     }else if(wid == "813" && hei === "473"){

       size = {backdrop:"1.06",shifting:"1.11"}

     }else if(wid == "387" && hei === "473"){

       size = {backdrop:"1.1",shifting:"1.15"}

     }else if(wid == "813" && hei === "217"){

       size = {backdrop:"1.06",shifting:"1.17"}

     }else if(wid == "813" && hei === "185"){

       size = {backdrop:"1.06",shifting:"1.19"}

     }else if(wid == "529" && hei === "297"){

       size = {backdrop:"1.09",shifting:"1.17"}

     }else if(wid == "529" && hei === "217"){

       size = {backdrop:"1.09",shifting:"1.20"}

     }else if(wid == "529" && hei === "185"){

       size = {backdrop:"1.09",shifting:"1.22"}

     }else if(wid == "387" && hei === "217"){

       size = {backdrop:"1.12",shifting:"1.24"}

     }else if(wid == "387" && hei === "473"){

       size = {backdrop:"1.1",shifting:"1.15"}

     }else if(wid == "245" && hei === "350"){

       size = {backdrop:"1.12",shifting:"1.19"}

     }

     return size;
   }
}



// WEBPACK FOOTER //
// ./src/commonjs/comModule.js